import EndCardTpl from "../EndCardTpl";

export default class EndCardTplNative extends EndCardTpl {
    constructor() {
        super();
    }

    init({JsBridgeRes}) {
        super.init({JsBridgeRes});
    }

    show(res) {
        super.show(res);
    }
}